export const DETECTION_ALGORITHM_INFO_UPDATE_DATA = 'DETECTION_ALGORITHM_INFO_UPDATE_DATA';

export const DETECTION_ALGORITHM_INFO_UPDATE = 'DETECTION_ALGORITHM_INFO_UPDATE';
export const DETECTION_ALGORITHM_INFO_UPDATE_SUCCESS = 'DETECTION_ALGORITHM_INFO_UPDATE_SUCCESS';
export const DETECTION_ALGORITHM_INFO_UPDATE_ERROR = 'DETECTION_ALGORITHM_INFO_UPDATE_ERROR';

export const DETECTION_ALGORITHM_INFO_CREATE = 'DETECTION_ALGORITHM_INFO_CREATE';
export const DETECTION_ALGORITHM_INFO_CREATE_SUCCESS = 'DETECTION_ALGORITHM_INFO_CREATE_SUCCESS';
export const DETECTION_ALGORITHM_INFO_CREATE_ERROR = 'DETECTION_ALGORITHM_INFO_CREATE_ERROR';

export const DETECTION_ALGORITHM_INFO_DELETE = 'DETECTION_ALGORITHM_INFO_DELETE';
export const DETECTION_ALGORITHM_INFO_DELETE_SUCCESS = 'DETECTION_ALGORITHM_INFO_DELETE_SUCCESS';
export const DETECTION_ALGORITHM_INFO_DELETE_ERROR = 'DETECTION_ALGORITHM_INFO_DELETE_ERROR';

export const EDIT_FILTER_CONFIG = 'EDIT_FILTER_CONFIG';
export const EDIT_FILTER_CONFIG_SUCCESS = 'EDIT_FILTER_CONFIG_SUCCESS';
export const EDIT_FILTER_CONFIG_ERROR = 'EDIT_FILTER_CONFIG_ERROR';

export const DETECTION_ALGORITHM_LIST = 'DETECTION_ALGORITHM_LIST';
export const DETECTION_ALGORITHM_LIST_SUCCESS = 'DETECTION_ALGORITHM_LIST_SUCCESS';
export const DETECTION_ALGORITHM_LIST_ERROR = 'DETECTION_ALGORITHM_LIST_ERROR';